import { createReducer } from '@reduxjs/toolkit';
import { handleActionStart, handleActionError } from 'store/utils';
import {
  fetchFoodData,
  updateSingleMeal,
  setCurrentPatient,
  clearCurrentPatient,
} from 'store/currentPatient/actions';

const initialState = {
  data: [],
  isLoading: false,
  error: null,
};

export default createReducer(initialState, {
  [fetchFoodData.STARTED]: handleActionStart,
  [fetchFoodData.SUCCEEDED]: (state, action) => {
    state.isLoading = false;
    state.error = null;
    state.data = action.payload.data;
  },
  [updateSingleMeal]: (state, action) => {
    state.isLoading = false;
    state.error = null;
    state.data = state.data.map(meal =>
      meal.food_logging_id === action.payload.data.food_logging_id
        ? action.payload.data
        : meal
    );
  },
  [fetchFoodData.FAILED]: handleActionError,
  [setCurrentPatient]: (_, action) => action.payload.foodData,
  [clearCurrentPatient]: () => initialState,
});
